<template>
  <div>
    <ValidationObserver ref="observer">
      <v-row justify="center">
        <v-col cols="12">
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" rules="required">
                <div
                  class="
                    text-start
                    mb-0
                    textLight--text
                    text-subtitle-2
                    font-weight-thin
                  "
                >
                  {{ $t("user.firstName") }}
                </div>
                <v-text-field
                  hide-details
                  v-model="data.firstName"
                  :error-messages="errors"
                  @click="error = false"
                  outlined
                  :append-icon="
                    !data.firstName && error ? 'mdi-alert-circle-outline' : null
                  "
                  dense
                  class="rounded-md text-body-2"
                >
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6" class="ps-2">
              <validation-provider v-slot="{ errors }" rules="required">
                <div
                  class="
                    text-start
                    mb-0
                    textLight--text
                    text-subtitle-2
                    font-weight-thin
                  "
                >
                  {{ $t("user.lastName") }}
                </div>
                <v-text-field
                  hide-details
                  v-model="data.lastName"
                  :error-messages="errors"
                  @click="error = false"
                  outlined
                  :append-icon="
                    !data.lastName && error ? 'mdi-alert-circle-outline' : null
                  "
                  dense
                  class="rounded-md text-body-2"
                >
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pt-5">
          <v-row>
            <v-col cols="12" md="6" class="pe-0">
              <div
                class="
                  text-start
                  mb-0
                  textLight--text
                  text-subtitle-2
                  font-weight-thin
                "
              >
                {{ $t("user.gender") }}
              </div>
              <v-radio-group hide-details="" v-model="data.gender" row>
                <v-radio
                  class="ma-0 pa-0 black--text"
                  color="textLight"
                  :label="val.text"
                  :value="val.value"
                  v-for="(val, index) in gender"
                  :key="index"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="6" class="ps-2">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }" rules="required">
                  <div
                    class="
                      text-start
                      mb-0
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                    "
                  >
                    {{ $t("user.dob") }}
                  </div>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-text-field
                      hide-details=""
                      :error-messages="errors"
                      v-model="data.dob"
                      outlined
                      dense
                      placeholder="DD/MM/YYYY"
                      append-icon="mdi-calendar-blank-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </validation-provider>
                </template>
                <v-date-picker
                  color="textLight"
                  v-model="date"
                  no-title
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required|email">
            <div
              class="
                text-start
                mb-0
                textLight--text
                text-subtitle-2
                font-weight-thin
              "
            >
              {{ $t("user.email") }}
            </div>
            <v-text-field
              hide-details
              v-model="data.email"
              :error-messages="errors"
              @click="error = false"
              outlined
              prepend-inner-icon="mdi-email-outline"
              :append-icon="
                !data.email && error ? 'mdi-alert-circle-outline' : null
              "
              dense
              class="rounded-md text-body-2"
            >
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required|max:10">
            <div
              class="
                text-start
                mb-0
                textLight--text
                text-subtitle-2
                font-weight-thin
              "
            >
              {{ $t("user.phone") }}
            </div>
            <v-text-field
              hide-details
              v-model="data.phone"
              type="number"
              :error-messages="errors"
              @click="error = false"
              outlined
              prepend-inner-icon="mdi-cellphone"
              :append-icon="
                !data.phone && error ? 'mdi-alert-circle-outline' : null
              "
              dense
              class="rounded-md text-body-2"
            >
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12">
          <v-btn
            depressed
            dense
            dark
            class="text-subtitle-1 rounded-md mb-2 mt-5"
            color="textLight"
            style="width: 100%"
            @click="submit"
          >
            {{ $t("user.signUp.continue").toUpperCase() }}
          </v-btn>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>
<script>
import "../../core-module/util/validationRules";
export default {
  props: {
    values: {
      type: Object,
    },
  },
  data() {
    return {
      error: false,
      data: this.values,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      gender: [
        { text: "Male", value: "MALE" },
        { text: "Female", value: "FEMALE" },
        { text: "Other", value: "OTHER" },
      ],
    };
  },
  watch: {
    date(val) {
      this.data.dob = this.formatDate(this.date);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateServer(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) this.error = true;
      else {
        this.data.dob = await this.formatDateServer(this.data.dob);
        this.$emit("completed", this.data);
      }
    },
  },
};
</script>
<style scoped>
.black--text /deep/ label {
  font-size: 13px;
}
</style>
